import * as React from "react";
import { Form } from "antd";
// const FormItem = Form.Item;
// const Option = Select.Option;
import { connect } from "react-redux";
//  数据模型
import Model from "../../viewModel";
// 小工具栏
import SmallTools from "../smallTools";

// import qs from 'qs'

// // 表单提交按钮组
// import SubmitButton from "../submitButton";

// 检索表单的布局逻辑
import { searchFormLayout } from "./searchFormLayout";

// import { getElement } from "./getElement";

import { PositionProperty } from "csstype";
import { FormProps } from "antd/lib/form";

// form中包含的组件类型
enum EFormType {
  input = 0,
  button = 1,
  dateRange = 2,
  select = 3,
  country = 4,
  city = 5,
  area = 6,
  // 国家，城市联动
  countryCity = 7,
  // 订单来源 二级联动
  secondaryLinkage = 8,
  // 贸易状态
  tsSecondarLinkage = 9,
  // 日期f范围控件
  rangePicker = 10,
  // 以文本显示
  text = 11,
  // 已文字链接显示
  linkText = 12,
  // 订单状态多选标签
  orderStatusTag = 13
}

// form中组件包含的属性
interface IFormData {
  // 标题
  label: string;
  // 默认值or值 可选 | 可由Rudex全局控制
  value?: any;
  // 组件类型
  type: EFormType;
  // 字段名称
  field: string;
  // 扩展字段，用于字段与字段关联度高的情况下
  extField1?: string;
  extField2?: string;
  extField3?: string;
  extField4?: string;
  extField5?: string;
  extFieldValue1?: string;
  extFieldValue2?: string;
  extFieldValue3?: string;
  extFieldValue4?: string;
  extFieldValue5?: string;
  // 值改变事件 | 用于更新State中的数据 | 也可由Rudex来更新（默认由Rudex提供更新方法）
  onChange?: any;
  onClick?: any;
  // 表达式 用于特殊的组件
  expression?: any;
  colSpan: any;
  labelCol: any;
  wrapperCol: any;
  // 数据源
  data: any;
  width?: any;
  // 提示语
  placeholder?: any;
  // 唯一识别码，目前用于控制字段的显示和隐藏
  key?: any;

}

// 创建表单组件需要的属性
interface ICreateFormProps {
  name?: any;
  // 表单数据源
  FormData: IFormData[];
  // 表单字段集合
  CreateForm: any;
  ModelName: string;
  // 模型名称 | Redux中state的名称
  Model: string;
  // 更新Redux的state
  setValue: any;
  setFieldValue: any,
  addModel: any;
  resetModel: any;
  updateHotKey: any;
  //组件名称
  componentName?: any;
  // 获取表单字段配置信息
  getSett?: any;
  // 用于保存所有调整字段后的配置信息
  settInfo?: any;
  // 需要隐藏 or 显示的字段
  fieldList?: any;
  // 提供给外部当前对象
  onRef?: any;
  // 唯一标识
  cuid?: any;
  // 用于找到父节点的选择器
  containerBody?: any;
}

class CreateForm extends React.Component<ICreateFormProps & FormProps> {
  state = {
    // 字段抽屉框组件数据
    fieldDrawerData: [],
    // 字段抽屉组件返回的需要隐藏的字段
    targetKeys: [],
    rendForm: [],
    isLoad: false
  };

  rendForm = [];

  constructor(props: ICreateFormProps) {
    super(props);

    // 提供给外部的当前对象的引用
    this.props.onRef(this);
    const model = new Model[this.props.Model]();

    for (let item of this.props.FormData) {
      if (item.field && item.value) {
        model[item.field] = item.value;
      }

      // 循环给扩展字段赋值
      for (let i = 1; i <= 5; i++) {
        if (item[`${"extField" + i}`] && item[`${"extFieldValue" + i}`]) {
          model[item[`${"extField" + i}`]] = item[`${"extFieldValue" + i}`];
        }
      }
    }

    // 创建Rudex state
    this.props.addModel({
      modelName: this.props.ModelName,
      model: model
    });
    this.getValue = this.getValue.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  //componentWillMount() {
  componentDidMount() {
    this.getTransferField();

    this.props.getSett({
      uuid: 666,
      name: this.props.componentName
    });

    // const { saler } = qs.parse(window.location.search, { ignoreQueryPrefix: true })
    // console.warn(this.props.setFieldValue({ field: "headId", value: saler }))

    // setTimeout(() => {
    //   this.props.setValue({
    //     formInfo: this.props.CreateForm,
    //     model: this.props.ModelName,
    //     field: "headId",
    //     value: saler
    //   });
    // }, 3000)

    // this.props.setValue(obj);
  }

  // shouldComponentUpdate(nextProps: any, nextState: any, nextContext: any) {
  //   if (
  //     nextProps.fieldList &&
  //     nextProps.fieldList.length > 0 &&
  //     nextState.isLoad === false
  //   ) {
  //     const rendForm = this.getFormFeild(nextProps.fieldList);
  //     this.setState({
  //       rendForm,
  //       isLoad: true
  //     });
  //     return true;
  //   } else if (nextState.isLoad) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }

  onChange(e) {
    const field: string = e.target.attributes["data-field"].value;
    // console.warn(e.target.value)
    this.props.setValue({
      formInfo: this.props.CreateForm,
      model: this.props.ModelName,
      field,
      value: e.target.value
    });
  }

  // 自动补全事件
  onAutoCompleteChange = (field, value) => {
    this.props.setValue({
      formInfo: this.props.CreateForm,
      model: this.props.ModelName,
      field,
      value: value
    });
  };

  getValue(field) {
    for (const key in this.props.CreateForm) {
      if (key === field) {
        return this.props.CreateForm[key];
      } else {
        continue;
      }
    }
    return null;
  }

  // 获取穿梭框需要的字段
  getTransferField = () => {
    const tFieldkData: any = [];
    for (const item of this.props.FormData) {
      if (item.field) {
        const data = {
          key: item.field,
          title: item.label,
          description: "",
          chosen: 1
        };
        tFieldkData.push(data);
      }
    }

    this.setState({
      fieldDrawerData: tFieldkData
    });
  };

  // 字段抽屉组件回调事件，用于返回已被设置为隐藏的字段
  onFieldDrawerSubmit = targetKeys => {
    //this.setState({targetKeys:targetKeys rendForm: this.getFormFeild(targetKeys) });
    this.setState({ targetKeys: targetKeys });
  };

  // 获取字段显示/隐藏的抽屉框
  getFieldDrawerParam = () => {
    return {
      componentName: this.props.componentName,
      data: this.state.fieldDrawerData,
      onSubmit: this.onFieldDrawerSubmit
    };
  };

  getFormFeild = (targetKeys, containerBody) => {
    return searchFormLayout(
      targetKeys,
      this.props.FormData,
      this.getValue,
      this.props.ModelName,
      this.onChange,
      modelName => {
        this.props.resetModel({ modelName, model: this.props.Model });
        this.forceUpdate();
      },
      (field, data) => {
        // 更新数据
        this.props.setValue({
          formInfo: this.props.CreateForm,
          model: this.props.ModelName,
          field,
          value: data
        });
      },
      containerBody,
      this.onAutoCompleteChange,
      this.props.updateHotKey
    );
  };

  // 提供给外部的修改表单数据的方法
  public createFormSetValue = (field, value) => {
    this.props.setValue({
      formInfo: this.props.CreateForm,
      model: this.props.ModelName,
      field,
      value: value
    });
  };

  render() {
    const rendForm = this.getFormFeild(
      this.props.fieldList,
      "#" + this.props.cuid
    );
    const getForm = () => {
      return (
        <Form
          id={this.props.cuid}
          className="ant-advanced-search-form"
          style={{ position: "relative" as PositionProperty }}
        >
          {rendForm}
        </Form>
      );
    };
    return (
      <SmallTools
        cuid={this.props.cuid}
        content={getForm()}
        isOpenEnlarge={false}
        isOpenFieldDrawer={false}
        fieldDrawer={this.getFieldDrawerParam()}
      />
    );
  }
}

const mapState = state => ({
  // 用于保存所有调整字段后的配置信息
  settInfo: state.extFunc
});

const mapDispatch = dispatch => {
  return {
    getSett: dispatch.extFunc.getSett,
    setValue: dispatch.antDemo.setValue,
    setFieldValue: dispatch.antDemo.setFieldValue,
    addModel: dispatch.antDemo.addModel,
    resetModel: dispatch.antDemo.resetModel,
    updateHotKey: dispatch.hotkey.updateHotKey
  };
};

export default connect(
  mapState,
  mapDispatch
)(CreateForm);
